<script lang="ts" setup>
    import { Validation } from '~/data/Validation'

    const {
        field = undefined,
        taxonomies = undefined,
        label = '',
        placeholder = '',
        defaultValue = '',
        showLabel = true,
        required = false,
        width = 100,
        fitContent = false,
    } = defineProps<{
        field?: Field
        taxonomies?: string[]
        label?: string
        placeholder?: string
        defaultValue?: string
        showLabel?: boolean
        required?: boolean
        width?: number
        fitContent?: boolean
    }>()

    const model = defineModel()

    /** @todo: support multiple terms */
    let taxonomy: string | undefined

    if (taxonomies && taxonomies.length > 0) {
        taxonomy = taxonomies[0]
    } else if (field && field.taxonomies && field.taxonomies.length > 0) {
        taxonomy = field.taxonomies[0]
    }

    if (!taxonomy) {
        throw new Error('No taxonomy provided')
    }

    const { data } = await useStatamicTaxonomies().getTaxonomyTerms({
        taxonomy,
    })

    const termSelectField = {
        type: 'select',
        validate: required ? [Validation.required] : [],
        handle: taxonomy,
        display: label,
        width,
        placeholder,
        options: data.value?.map((term) => ({
            key: term.slug ?? '',
            value: term.title,
        })),
    } as Field

    if (field) {
        termSelectField.handle = field.handle
        termSelectField.display = field.display
        termSelectField.width = field.width
        termSelectField.placeholder = field.display
    }
</script>

<template>
    <InputSelect
        :field="termSelectField"
        :showLabel="showLabel"
        :default-value="defaultValue || ' '"
        v-model="model"
        :fitContent="fitContent"
    />
</template>
